import * as React from 'react';
import { getPropInSafe } from '@seeneco-ui/core/utils';
import Icon from '@seeneco-ui/core/components/icon';
import Button from '@seeneco-ui/core/components/button';
import IconLink from '@seeneco-ui/core/components/icon-link';
import AccountIcon from '@seeneco-ui/core/components/account-icon';

import {
	integrationHelpLinks,
	rangeCmsNamesMap,
} from '../../../../shared/constants/cms';
import {
	Root,
	CMSCard,
	CMSCardHeader,
	CMSIconLayout,
	CMSName,
	CMSControlsLayout,
	AddButtonLayout,
} from './styled';


type Props = {
	isFetching: boolean;
	cmsMap: Record<string, CashManagementSystem>;
	accountList: Array<ExternalSystemAccount>;
	ssiMap: Record<string, SubsystemInstance>;
	onAdd: (cmsGUID: string) => (e) => void;
}

const NotConnectedServicesList: React.SFC<Props> = (props) => {
	const {
		isFetching,
		accountList,
		cmsMap,
		ssiMap,
		onAdd,
	} = props;
	
	if (isFetching) return null;

	const cmsList = cmsMap ? Object.keys(cmsMap).map(key => cmsMap[key]) : [];
	const cmsGUIDList = accountList.map(el => getPropInSafe(ssiMap, o => o[el.ExternalSSInstanceID].GUID, ''));
	const notConnectedCMSList = cmsList
		.filter(cms => !cmsGUIDList.some(guid => guid === cms.SubsystemInstanceGUID))
		.sort((a, b) => rangeCmsNamesMap[a.SubsystemInstanceGUID] - rangeCmsNamesMap[b.SubsystemInstanceGUID])

	if (notConnectedCMSList.length === 0) return null;

	return (
		<Root>
			{
				notConnectedCMSList.map(cms => {
					return (
						<CMSCard key={cms.ID}>
							<CMSCardHeader>
								<CMSIconLayout>
									<AccountIcon
										isBank
										bankName={cms.Name}
										width={36}
										height={36}
									/>
								</CMSIconLayout>
								<CMSName>{cms.Name}</CMSName>
							</CMSCardHeader>
							<CMSControlsLayout>
								<AddButtonLayout>
									<Button
										appearance='text'
										size='small'
										onClick={onAdd(cms.SubsystemInstanceGUID)}>
										<Icon type='add' color='primary' width={18} height={18} />
										Подключить учетную запись
									</Button>
								</AddButtonLayout>
								<IconLink
									to={integrationHelpLinks[cms.SubsystemInstanceGUID]}
									rel='noopener'
									target='_blank'
									rightIconType='link-external'
									iconSize={7}
									iconColor='muted'
									color='muted'>
									Как подключить?
								</IconLink>
							</CMSControlsLayout>
						</CMSCard>
					);
				})
			}
		</Root>
	);
}

export default NotConnectedServicesList;
